//import SecureLS from "secure-ls";

const isProduction = process.env.NODE_ENV === 'production';

/*
const secure = {
  encodingType: 'des', 
  isCompression: false, 
  encryptionSecret: 'VD{F(Nv(2]z=2cBg#2Qs'
}
*/

export const ChangeLocalState = (name: string, key:string, value:string | number | boolean | object) => {
  const currentState = GetLocalState(name) || {};
  
  if ( !isProduction ) {
    SetLocalState(name, {
      ...currentState,
      [key]: value
    });
  }
  else {
    SetLocalState(name, {
      ...currentState,
      [key]: value
    });
  }
};

export const SetLocalState = (name: string, state:object) => {

  if ( !isProduction ) {
    window.localStorage.setItem(name, JSON.stringify(state));
  }
  else {

    window.localStorage.setItem(name, JSON.stringify(state));
    //var ls = new SecureLS(secure);
    //    ls.set(name, JSON.stringify(state)); 

  }
  
};

export const GetLocalState = (name:string) => {
  const data = window.localStorage.getItem(name);
  
  if (!data) return {};
  
  try {
    if (!isProduction) {
      return JSON.parse(data);
    }
    else {
      return JSON.parse(data);
    }
  } catch (error) {
    console.error('LocalStorage parse error:', error);
    return {};
  }
};